var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.2-Dashboard:-Tab---Layout",
    transform: "translate(-506.000000, -184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(260.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(242.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Size",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 1.11199938e-12,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0596987,14.4403406 L8.74575683,14.4403406 L6.95037067,14.4403406 L7.68256726,13.3119554 L8.58026034,11.932818 L8.58026034,7.95087217 L8.58026034,5.81446294 L8.58026034,3.40724128 L15.2251951,3.40724128 L15.2251951,5.81446294 L15.2251951,7.95087217 L15.2251951,11.932818 L16.1228882,13.3119554 L16.8550848,14.4403406 L15.0596987,14.4403406 Z M16.7297087,11.4313135 L16.7297087,6.44635863 L16.7297087,4.3099494 L16.7297087,3.40724128 C16.7297087,3.35709083 16.7246936,3.30192533 16.7246936,3.25177488 C16.7196786,3.20663947 16.7146635,3.16651911 16.7046335,3.12138371 C16.654483,2.82549604 16.5190768,2.56972874 16.2933998,2.34405171 C16.0627077,2.11837468 15.8069404,1.97795342 15.5110527,1.92780296 C15.4659173,1.91777287 15.4257969,1.91275783 15.3806615,1.90774278 C15.3305111,1.90774278 15.2753456,1.90272774 15.2251951,1.90272774 L8.58026034,1.90272774 C8.53010988,1.90272774 8.47494439,1.90272774 8.42479394,1.90774278 C8.37965853,1.91275783 8.33953817,1.91777287 8.29440276,1.92780296 C7.9985151,1.97795342 7.7427478,2.11837468 7.51707077,2.34405171 C7.28637869,2.56972874 7.15097247,2.82549604 7.10082202,3.12138371 C7.09079193,3.16651911 7.08577689,3.20663947 7.08076184,3.25177488 C7.0757468,3.30192533 7.0757468,3.35709083 7.0757468,3.40724128 L7.0757468,4.3099494 L7.0757468,6.44635863 L7.0757468,11.4313135 L5.06972874,14.4403406 L5.06972874,15.9448541 L7.24124329,15.9448541 L11.213159,15.9448541 L11.213159,21.2106515 L11.9052353,21.9027277 L12.5922964,21.2106515 L12.5922964,15.9448541 L16.5642122,15.9448541 L18.7357267,15.9448541 L18.7357267,14.4403406 L16.7297087,11.4313135 Z",
    id: "Fill-1",
    fillOpacity: 1,
    fill: "RGBA(0, 0, 0, 0.16)",
    transform: "translate(11.902728, 11.902728) rotate(45.000000) translate(-11.902728, -11.902728) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.32cc981048a49bb5cb62eb9874243c96.svg";
export { ForwardRef as ReactComponent };